import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Stack, Typography, Link, } from '@mui/material';
// import { observer } from 'mobx-react-lite';
import { Link as RouterLink } from 'react-router-dom';
import { useStore, useTokens, } from '@mcn-platform/models';
import CategoryMenu from './CategoryMenu';
import CategoryItem from './CategoryItem';
export const categorySeparators = {
    asetrick: { value: 'asetrick', label: 'Asterick' },
    blackPointBullet: { value: 'blackPointBullet', label: 'Black Point Bullet' },
    circleBullet: { value: 'circleBullet', label: 'Circle bullet' },
    dash: { value: 'dash', label: 'Dash' },
    emptyBullet: { value: 'emptyBullet', label: 'Empty bullet' },
    square: { value: 'square', label: 'Square' },
    verticalBar: { value: 'verticalBar', label: 'Vertical Bar' },
    whitePointBullet: { value: 'whitePointBullet', label: 'White Point Bullet' },
};
const getSeparator = (value) => {
    switch (value) {
        case categorySeparators.asetrick.value:
            return '*';
        case categorySeparators.blackPointBullet.value:
            return '⦿';
        case categorySeparators.circleBullet.value:
            return '•';
        case categorySeparators.dash.value:
            return '⁃';
        case categorySeparators.emptyBullet.value:
            return '○';
        case categorySeparators.square.value:
            return '⌑';
        case categorySeparators.verticalBar.value:
            return '|';
        case categorySeparators.whitePointBullet.value:
            return '⦾';
        default:
            return '';
    }
};
const LearningBoardLink = observer(({ editData }) => {
    const store = useStore();
    const tokens = useTokens();
    const { currentLearningBoard, currentPortal } = useStore();
    const { showLearningBoard, showUserNameInLearningBoard, } = currentPortal;
    // console.log('currentLearningBoard', currentLearningBoard);
    if (!currentLearningBoard) {
        return null;
    }
    let label = tokens.getToken('learningBoardName');
    if (store.currentCustomer.name !== '') {
        if (showUserNameInLearningBoard) {
            label = `${store.currentCustomer.name}'s ${label}`;
        }
    }
    if (!showLearningBoard) {
        return null;
    }
    return (_jsx(Link, { component: RouterLink, underline: "none", to: "learningBoard", className: "pageMenu", onClick: (ev) => editData && editData.preNavigationHook('learningBoard', ev), sx: {
            typography: 'subtitle1',
            letterSpacing: 'normal',
            justifyContent: { xs: 'end', sm: 'start' },
            p: { xs: '6px 15px' },
            borderRadius: '5px',
            padding: '6px 8px',
            '&:hover': { background: (theme) => theme.palette.backgroundLightHover },
            color: 'site.pageMenus.color',
            fontWeight: 'site.pageMenus.fontWeight',
            fontSize: 'site.pageMenus.fontWeight',
            textTransform: 'site.pageMenus.textTransform',
            backgroundColor: 'site.pageMenus.backgroundColor',
            borderColor: 'site.pageMenus.borderColor',
        }, children: label }, "learningBoard"));
});
const CategoryNav = ({ rootCategory, limitToPageWidth, showSubCategoryDropdowns, editData, settings: { defaultSeparatorValue }, }) => {
    const [isMobileView, setIsMobileView] = useState(false);
    const handleResize = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth <= 600 && !isMobileView) {
            setIsMobileView(true);
        }
        else if (windowWidth > 600 && !isMobileView) {
            setIsMobileView(false);
        }
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize, false);
        handleResize();
    });
    if (isMobileView) {
        return (null);
    }
    return (_jsx("nav", { children: _jsxs(Stack, { direction: "row", divider: (_jsx(Typography, { component: "span", sx: {
                    px: 2.5,
                    color: (theme) => (theme.portal.menu.menuSeparator.color),
                }, children: getSeparator(defaultSeparatorValue) })), sx: {
                pl: 2.5,
                height: 61,
                alignItems: 'center',
                backgroundColor: (theme) => (theme.portal.site?.background?.color),
                ...(limitToPageWidth && {
                    maxWidth: 1200,
                    marginX: 'auto',
                    width: '100%',
                }),
            }, children: [rootCategory.subCategories.map((category) => {
                    // console.log('check rootcategory', rootCategory);
                    // console.log('check category Menu', CategoryMenu);
                    if (showSubCategoryDropdowns && category.subCategories.length > 0) {
                        return (_jsx(CategoryMenu, { editData: editData, category: category }, category.id));
                    }
                    return (_jsx(CategoryItem, { category: category, editData: editData }, category.id));
                }), _jsx(LearningBoardLink, { editData: editData })] }) }));
};
CategoryNav.defaultProps = {
    settings: {
        defaultSeparatorValue: categorySeparators.verticalBar.value,
    },
};
CategoryNav.meta = {
    group: 'portal',
    name: 'Top Category Nav',
    description: 'Shows Categories global',
    props: [
        {
            key: 'rootCategory',
            name: 'Root Category',
            type: 'category',
            description: 'Category that holds the top level categories beneath it.',
        },
        {
            key: 'showSubCategoryDropdowns',
            name: 'Show SubCategory Dropdowns',
            type: 'boolean',
            description: 'Instead of linking to the category, show the menu of SubCategories.',
        },
        {
            key: 'settings.defaultSeparatorValue',
            name: 'Category separator',
            type: 'array',
            items: categorySeparators,
            description: 'Seperator icon that appears between Top-Level Category',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'CategoryNav',
        props: {
            rootCategory: '@rootCategory',
            settings: {
                defaultSeparatorValue: categorySeparators.verticalBar.value,
                limitToPageWidth: true,
            },
        },
    },
};
export default observer(CategoryNav);
//# sourceMappingURL=CategoryNav.js.map